export default "/dai-usdc.88c0c8f8f37505fe517ef63e3b9997aa.svg";